import * as types from '../actiontypes';
import {
	API_RESOURCES,
	createApiReadAction,
	createApiCreateAction,
	createApiDeleteAction,
	createApiPatchAction,
	createApiUpdateAction,
	HTTP_REQUEST_METHODS
} from '../../util/api';

export const getDeficiency = (engagementId, queryParameters, trackWithArea) => {
	return createApiReadAction(
		types.GET_ALL_DEFICIENCIES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: undefined
		},
		queryParameters,
		{
			resolve: true
		},
		undefined,
		trackWithArea
	);
};

export const createDeficiency = (engagementId, data, resolve = undefined, updateState = true) => {
	return createApiCreateAction(
		types.CREATE_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: null
		},
		data,
		{resolve: resolve, actionArgs: {updateState}}
	);
};

export const getDeficiencyById = (engagementId, deficiencyId, queryParameters, actionArgs, trackWithArea) => {
	return createApiReadAction(
		types.GET_DEFICIENCY_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId
		},
		queryParameters,
		{
			...actionArgs,
			resolve: true
		},
		undefined,
		trackWithArea
	);
};

export const addControlToDeficiency = (engagementId, deficiencyId, controlId, customErrorMessage) => {
	return createApiCreateAction(
		types.ADD_CONTROL_TO_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.CONTROLS]: null
		},
		{controlId: controlId},
		{resolve: true, customErrorMessage}
	);
};

export const removeControlFromDeficiency = (engagementId, deficiencyId, controlId, customErrorMessage) => {
	return createApiDeleteAction(
		types.REMOVE_CONTROL_FROM_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.CONTROLS]: controlId
		},
		{resolve: true, customErrorMessage}
	);
};

export const addAssertionToDeficiency = (engagementId, deficiencyId, assertionId, payload, customErrorMessage) => {
	return createApiCreateAction(
		types.ADD_ASSERTION_TO_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.ASSERTIONS]: null
		},
		{assertionId: assertionId},
		{payload: payload, resolve: true, customErrorMessage}
	);
};

export const removeAssertionFromDeficiency = (engagementId, deficiencyId, assertionId, customErrorMessage) => {
	return createApiDeleteAction(
		types.REMOVE_ASSERTION_FROM_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.ASSERTIONS]: assertionId
		},
		{payload: assertionId, resolve: true, customErrorMessage}
	);
};

export const addGroupComponentToDeficiency = (engagementId, deficiencyId, gaComponentId,customErrorMessage) => {
	return createApiCreateAction(
		types.ADD_GROUP_COMPONENT_TO_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.GROUPCOMPONENTS]: null
		},
		{groupcomponentId: gaComponentId},
		{resolve: true, customErrorMessage}
	);
};

export const removeGroupComponentFromDeficiency = (engagementId, deficiencyId, gaComponentId,customErrorMessage) => {
	return createApiDeleteAction(
		types.REMOVE_GROUP_COMPONENT_FROM_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.GROUPCOMPONENTS]: gaComponentId
		},
		{resolve: true, customErrorMessage}
	);
};

export const addITControlToDeficiency = (engagementId, deficiencyId, itControlId, customErrorMessage) => {
	return createApiCreateAction(
		types.ADD_ITCONTROL_TO_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.ITCONTROLS]: null
		},
		{itControlId: itControlId},
		{resolve: true, customErrorMessage}
	);
};

export const removeITControlFromDeficiency = (engagementId, deficiencyId, itControlId, customErrorMessage) => {
	return createApiDeleteAction(
		types.REMOVE_ITCONTROL_FROM_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.ITCONTROLS]: itControlId
		},
		{payload: itControlId, resolve: true, customErrorMessage}
	);
};

export const patchDeficiency = (engagementId, deficiencyId, payload) => {
	return createApiPatchAction(
		types.PATCH_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId
		},
		payload
	);
};

export const addStenitityToDeficiency = (engagementId, deficiencyId, entityId, customErrorMessage) => {
	return createApiCreateAction(
		types.ADD_STENTITY_TO_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: entityId,
			[API_RESOURCES.DEFICIENCY]: null
		},
		{deficiencyId: deficiencyId},
		{resolve: true, customErrorMessage}
	);
};

export const removeStenitityFromDeficiency = (engagementId, deficiencyId, entityId, customErrorMessage) => {
	return createApiDeleteAction(
		types.REMOVE_STENTITY_FROM_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.MULTIENTITIES]: entityId
		},
		{resolve: true, customErrorMessage}
	);
};

export const updateDeficiency = (engagementId, deficiencyId, data, actionArgs = {}) => {
	return createApiUpdateAction(
		types.UPDATE_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId
		},
		data,
		HTTP_REQUEST_METHODS.PUT,
		actionArgs,
		true,
		undefined
	);
};

export const deleteDeficiency = (engagementId, deficiencyId, payload = null) => {
	return createApiDeleteAction(
		types.DELETE_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId
		},
		{payload: payload},
		true,
		undefined
	);
};

export const getFormBodyRelatedDeficiencies = (engagementId, documentId, headerId, sectionId) => {
	return createApiReadAction(
		types.GET_FORM_BODIES_BY_BODYTYPEID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: documentId,
			[API_RESOURCES.FORMS.HEADERS]: headerId,
			[API_RESOURCES.FORMS.SECTIONS]: sectionId,
			[API_RESOURCES.FORMS.BODIES]: undefined
		},
		{},
		{resolve: true}
	);
};

export const addFormBodyOptionToDeficiency = (engagementId, deficiencyId, formBodyOptionId, customErrorMessage) => {
	return createApiCreateAction(
		types.ADD_FORMBODYOPTION_TO_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.FORMBODYOPTIONS]: null
		},
		{formBodyOptionId: formBodyOptionId},
		{resolve: true, customErrorMessage}
	);
};

export const removeFormBodyOptionFromDeficiency = (engagementId, deficiencyId, formBodyOptionId, customErrorMessage) => {
	return createApiDeleteAction(
		types.REMOVE_FORMBODYOPTION_FROM_DEFICIENCY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.DEFICIENCY]: deficiencyId,
			[API_RESOURCES.FORMBODYOPTIONS]: formBodyOptionId
		},
		{resolve: true, customErrorMessage}
	);
};
